import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { fetchTaxRequest, saveBill, clearCart, resetSavedBill, fetchBillItems, addItemToCart } from "../../redux/action";
import { toast, ToastContainer } from "react-toastify";
import SmsPopup from "../../component/SMS/SmsPopup"
import "../Tables/BillPage.css";
import SelectItem from '../../component/MenuCard/SelectItem';
import PrintBill from "../../component/PrintBill/PrintBill";
import PrintKot from "../../component/PrintKOT/PrintKOT";
import { CodeIcon } from "lucide-react";
import BackButton from "../../component/BackButton/BackButton";
import PaymentAllocationEditor, { createPaymentAllocation, getPaymentValidationError, summarizePayments } from "../../component/Billing/PaymentAllocationEditor";
import { calculateBillTotals } from "../../Utills/billingTaxCalculator";
import { useTranslation } from "react-i18next";

const BillPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const roleId = Number(JSON.parse(localStorage.getItem("admin_token_info") || "{}").roleId);
  const billRef = useRef();
  const kotRef = useRef();

  const { tableName: urlTableName } = useParams();
  const tableName = urlTableName || "DIRECT_BILL";

  const billTaxDetails = location.state?.billTaxDetails;

  console.log("billTaxDetails",billTaxDetails)

  const [showSmsPopup, setShowSmsPopup] = useState(false);
  const [appliedServiceCharge, setAppliedServiceCharge] = useState(true);
  const [discount, setDiscount] = useState(0);
  const [discountType, setDiscountType] = useState("");
  const [appliedDiscount, setAppliedDiscount] = useState(0);
  const [OrderType, setOrderType] = useState("DINE_IN");
  const [payments, setPayments] = useState([createPaymentAllocation(0)]);
  const [complimentaryItems, setComplimentaryItems] = useState(() => new Set());
  const menuList = useSelector((state) => state?.user?.menu);
  const fullCartState = useSelector((state) => state?.user?.cart);
  const tax = useSelector((state) => state?.admin?.tax);
  const savedBill = useSelector((state) => state.admin.savedBill);
  const loading = useSelector(state => state.admin.loading);
  const draftBill = useSelector(state => state.admin.billItem);
  const [buttonType, setButtonType] = useState("");
  const cart = fullCartState?.[tableName] || {};
    console.log("tableName", tableName)
  console.log("draftBill", draftBill)
  console.log("savedBill", savedBill)

  useEffect(() => {
   
    console.log("savedBill?.billId",savedBill?.billId)
    console.log("buttonType",buttonType)

    if (savedBill?.billId && buttonType === "Paid&Print") {
      handlePrintBill_Kot();

      setTimeout(() => {
        handlePrintKot();
      }, 1500);
    } else if (savedBill?.billId && buttonType === "Paid&Print_kot") {
      handlePrintKot();
    } else if (savedBill?.billId && buttonType === "Paid&Print_bill") {
      handlePrintBillOnly();
    } else if (savedBill?.billId && buttonType === "") {
      console.log("inside else if ",buttonType)

      setButtonType(""); 
      dispatch(clearCart());
      dispatch(resetSavedBill());
     // navigate("/menu");
      navigate("/menu", { replace: true, state: {} });
    }
  }, [savedBill, buttonType]);

 useEffect(() => {
  const currentCart = fullCartState?.[tableName];
  const isCartEmpty = !currentCart || Object.keys(currentCart).length === 0;

  if (Array.isArray(draftBill) && draftBill.length > 0 && isCartEmpty) {
    dispatch({
      type: 'LOAD_DRAFT_INTO_CART',
      payload: {
        tableName: tableName, // Use variable tableName ("DIRECT_BILL" or table number)
        billId: billTaxDetails?.billId || 0,
        billItems: draftBill,
      },
    });
  }
}, [draftBill, billTaxDetails, tableName, fullCartState, dispatch]);

    useEffect(() => {

    dispatch(fetchTaxRequest());

    if (billTaxDetails) {
      dispatch(fetchBillItems(billTaxDetails.billId));
    }
  }, [billTaxDetails, dispatch]);

  const handlePrintBill_Kot = useReactToPrint({
    contentRef: billRef,
    onAfterPrint: () => {
      handlePrintKot();   // print KOT after bill
    }
  });


  const handlePrintBillOnly = useReactToPrint({
    contentRef: billRef,
    onAfterPrint: () => {
      setButtonType("");
      dispatch(clearCart());
      dispatch(resetSavedBill());
      navigate("/menu");
    }
  });

  const handlePrintKot = useReactToPrint({
    contentRef: kotRef,
    onAfterPrint: () => {
      setButtonType("");
      dispatch(clearCart());
      dispatch(resetSavedBill());
      navigate("/menu");
    }
  });

  console.log("cart", cart)
  console.log("menuList", menuList)

  // const cartItems = () => {
  //      // Case 1: draftBill exists
  // // if (draftBill && Array.isArray(draftBill) && draftBill.length > 0) {
  // //   return draftBill.map((item, idx) => ({
  // //     billId: billTaxDetails?.billId || null,
  // //     billItemId: item.billItemId || item.id || null,
  // //     menuId: item.menuId,
  // //     foodName: item.foodName || item.name || "Unknown Item",
  // //     price: item.price || 0,
  // //     selected: item.quantity || item.selected || 1,
  // //     selectedTab: item.selectedTab || item.categoryId || "",
  // //     selectedSize: item.selectedSize || null,
  // //     cartKey: item.billItemId || idx
  // //   }));
  // // }


  //   return Object.entries(cart).map(([cartKey, c]) => {
  //     const baseItem = menuList?.categories?.find(cat => cat.categoryId === c.selectedTab)
  //       ?.items.find(item => item.menuId === c.menuId);
      
  //     const displayName = c.selectedSize
  //       ? `${c.name || baseItem?.foodName || "Unknown"} (${c.selectedSize.sizeName})`
  //       : c.name || baseItem?.foodName || "Unknown";
      
  //     return {
  //       billId: c.billId || null,
  //       billItemId: c.billItemId || null,
  //       menuId: c.menuId,
  //       foodName: displayName,
  //       price: c.price, 
  //       selected: c.selected, 
  //       selectedTab: c.selectedTab,
  //       selectedSize: c.selectedSize,
  //       cartKey: cartKey
  //     };
  //   });
  // };

  // 🌟 Unified Item Resolver: Combines Draft Items + Newly Added Cart Items
   // 🌟 Clean Cart Resolver: Reads directly from Redux Cart (Hydrated by LOAD_DRAFT_INTO_CART + Menu additions)
const cartItems = () => {
  return Object.entries(cart).map(([cartKey, c]) => {
    const baseItem = menuList?.categories?.find(cat => cat.categoryId === c.selectedTab)
      ?.items.find(item => item.menuId === c.menuId);

    const displayName = c.selectedSize
      ? `${c.name || baseItem?.foodName || "Unknown"} (${c.selectedSize.sizeName})`
      : c.name || baseItem?.foodName || "Unknown";

    return {
      billId: c.billId || billTaxDetails?.billId || null,
      billItemId: c.billItemId || null,
      menuId: c.menuId,
      foodName: displayName,
      price: c.price, 
      selected: c.selected, 
      selectedTab: c.selectedTab,
      selectedSize: c.selectedSize,
      cartKey: cartKey,
      selectedAddons: c.selectedAddons || [],
      addonSummary: c.addonSummary || baseItem?.addonSummary || ""
      ,taxCategoryId: baseItem?.taxCategoryId
      ,hsnSacCode: baseItem?.hsnSacCode
      ,isTaxExempt: baseItem?.isTaxExempt
      ,isDiscountEligible: baseItem?.isDiscountEligible ?? true
      ,isComplimentary: complimentaryItems.has(cartKey) || Boolean(c.isComplimentary)
    };
  });
};


  const itemList = cartItems();

  console.log("itemList", itemList)




  console.log("tax.........", tax)

  const { cgst, sgst, serviceCharge, showCGST, showSGST, showServiceCharge } = tax || {};
  const calculated = calculateBillTotals({ items: itemList, settings: tax || {}, orderMode: OrderType, discount: appliedDiscount, applyServiceCharge: appliedServiceCharge });
  const { subtotal: subTotal, cgstAmount, sgstAmount, serviceChargeAmount, grandTotal, roundOff, payableAmount, packagingCharge, deliveryCharge } = calculated;
  const deliveryOptions = [
    { label: "Dine In", value: "DINE_IN" },
    { label: "Pick Up", value: "PICK_UP" },
    { label: "Delivery", value: "DELIVERY" },
  ];

  console.log("cgstAmount", cgstAmount)
  console.log("sgstAmount", sgstAmount)
  console.log("serviceChargeAmount", serviceChargeAmount)
  console.log("showCGST", showCGST)
  console.log("tax", tax)

  const paymentSummary = summarizePayments(payments);

  const handleApplyDiscount = () => {
    const discountValue = Number(discount) || 0;

    // Prevent discount greater than subtotal
    if (discountValue > subTotal) {
      toast.info("Discount cannot be greater than Subtotal");
      return;
    }
    setAppliedDiscount(discountValue);
  };

  const handleSendSMS = () => {
    // Placeholder: integrate with SMS API (like Twilio, MSG91, etc.)
    //toast.info(`Bill for Order #${billDetails.id} sent via SMS!`);
  };

  const data = (isPaid, status) => ({
    billId: billTaxDetails?.billId || Object.values(cart)?.[0]?.billId || "00000000-0000-0000-0000-000000000000",
    tokenNumber: billTaxDetails ? billTaxDetails?.tokenNumber : '',
    tableNumber: '',
    subTotal: subTotal,
    serviceChargePercent: serviceCharge,
    serviceChargeAmount: serviceChargeAmount,
    isServiceChargeApplied: appliedServiceCharge,
    cGSTPercent: cgst,
    cGSTAmount: cgstAmount,
    sGSTPercent: sgst,
    sGSTAmount: sgstAmount,
    packagingCharge,
    deliveryCharge,
    discountAmount: appliedDiscount,
    discountType: discountType || "N/A",
    grandTotal: grandTotal,
    settlementAmount: paymentSummary.settlementAmount,
    changeReturn: paymentSummary.changeReturn,
    paymentMode: paymentSummary.paymentMode,
    orderMode: OrderType,
    isPaid: isPaid,
    billStatus: status,
  });

  const handleSaveBill = (status) => {

    const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";
    const payload = itemList.map(item => ({
      billId: billTaxDetails?.billId || item.billId || Object.values(cart)[0]?.billId || EMPTY_GUID,
      billItemId: item.billItemId || EMPTY_GUID,
      menuId: item.menuId, // Guid
      name: item.foodName || "", // string 
      price: item.price, // decimal 
      quantity: item.selected, // int 
      totalPrice: item.price * item.selected ,// decimal,
      addonSummary: "add ons: " + (item.selectedAddons && item.selectedAddons.length > 0 ? item.selectedAddons.map(addon => addon.itemName).join(", ") : "") || item.addonSummary,
      isComplimentary: item.isComplimentary
    }));

    if (itemList.length === 0) {
      toast.warning(`Food item(s) not found.`);
      return;
    }

    const isPaidStatus = status === "Paid" || status.startsWith("Paid&");
    const actionReason = status === "Void" ? window.prompt("Reason for voiding this bill:") : null;
    if (status === "Void" && !actionReason?.trim()) return false;
    const paymentError = isPaidStatus ? getPaymentValidationError(payments, payableAmount) : null;
    if (paymentError) {
      toast.error(paymentError);
      return false;
    }

    console.log("payload clicked with Payment Method:", payload);
    console.log("data clicked with Payment Method:", data(true, status));

    if (status === "Paid&Print" || status === "Paid&Print_kot" || status === "Paid&Print_bill") {
      setButtonType(status);
    } else {
      setButtonType("");
    }

    if (status === "Paid" || status === "Paid&Print" || status === "Paid&Print_kot" || status === "Paid&Print_bill") {

      const paidData = data(true, "Paid");
      console.log("Paid clicked with Payment Method:", paidData);
      dispatch(saveBill(paidData, payload.map(item => ({ ...item, foodOrderId: item.foodOrderId || item.orderId || null })), 1, undefined, paymentSummary.payments))

    } else {

      const draftData = data(false, status);   // Draft and Void bill
      console.log("Draft clicked with Payment Method:", draftData);
      dispatch(saveBill(draftData, payload.map(item => ({ ...item, foodOrderId: item.foodOrderId || item.orderId || null })), 1, undefined, [], actionReason))

    }
  };
  const OrderAndCharges = { orders: itemList, charges: billTaxDetails }
  return (
    <div className="bill-page">
      <div className="bill-card">
        <div className="item-header">
          {/* <span onClick={() => navigate("/menu")} class="back-btn item-back-btn">← Back</span> */}
          <BackButton to="/menu" label="Back to Place Order" variant="subtle" classAttribute="item-back-btn" />
          <p className="item-title"></p>
        </div>

        <div className="bill-table-scroll" role="region" aria-label="Bill items and totals" tabIndex={0}>
        <table className="bill-table">
          <thead>
            <tr>
              <th>Item</th>
              <th>{t("Billing")}</th>
              {/* <th>Qty</th> */}
              <th>Qty</th>
              <th>Price</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {itemList.map((item, i) => (
              <tr key={item.cartKey || i}>
                <td>
                  <div>{item.foodName || item.name}</div>
                  {/* Case A: Jab freshly selected addons array ho */}
        {Array.isArray(item.selectedAddons) && item.selectedAddons.length > 0 ? (
          <div style={{ color: "#6b7280", fontSize: "11px", marginTop: "2px" }}>
            Add-ons: {item.selectedAddons.map((addon) => `${addon.itemName} (+₹${addon.price})`).join(", ")}
          </div>
        ) : item.addonSummary ? (
          /* Case B: Jab Draft se resume hua ho aur backend se addonSummary string aaya ho */
          <div style={{ color: "#6b7280", fontSize: "11px", marginTop: "2px" }}>
            {item.addonSummary.startsWith("Add-ons:") ? item.addonSummary : ` ${item.addonSummary}`}
          </div>
        ) : null}
                </td>
                <td><label className="complimentary-toggle"><input type="checkbox" checked={item.isComplimentary} onChange={() => setComplimentaryItems((current) => { const next = new Set(current); next.has(item.cartKey) ? next.delete(item.cartKey) : next.add(item.cartKey); return next; })} /> {t("Complimentary")}</label></td>
                {/* <td>{item.selected}</td> */}
                <td className='bill-menuSelectItem'><SelectItem menuId={item.menuId} tab={item.selectedTab} unit={item} isAvailable={true} selectedSize={item.selectedSize} tableName={tableName} /></td>
                <td>₹{item.price}</td>
                <td>₹{item.isComplimentary ? "0.00" : (item.selected * item.price).toFixed(2)}</td>
              </tr>
            ))}

          </tbody>
          <tfoot>

            {/* {billDetails.charges.map((item, i) => (
              <tr key={i}>
                <td colSpan="3">{item.name}</td>
                <td>{item.amount}</td>
              </tr>
            ))} */}

            <tr>
              <td colSpan="4">Sub Total</td>
              <td>₹{subTotal.toFixed(2)}</td>
            </tr>


            {serviceChargeAmount > 0 && (
              <tr>
                <td colSpan="4">Service Charge ({calculated.serviceChargePercent}%)</td>
                <td>₹{serviceChargeAmount.toFixed(2)}</td>
              </tr>
            )}

            {cgstAmount > 0 && (
              <tr>
                <td colSpan="4">CGST</td>
                <td>₹{cgstAmount.toFixed(2)}</td>
              </tr>
            )}

            {sgstAmount > 0 && (
              <tr>
                <td colSpan="4">SGST</td>
                <td>₹{sgstAmount.toFixed(2)}</td>
              </tr>
            )}

            {appliedDiscount > 0 && (
              <tr>
                <td colSpan="4">Discount</td>
                <td>- ₹{appliedDiscount.toFixed(2)}</td>
              </tr>
            )}



            {packagingCharge > 0 && <tr><td colSpan="4">Packaging</td><td>₹{packagingCharge.toFixed(2)}</td></tr>}
            {deliveryCharge > 0 && <tr><td colSpan="4">Delivery</td><td>₹{deliveryCharge.toFixed(2)}</td></tr>}
            <tr><td colSpan="4"><strong>Grand Total</strong></td>
            <td><strong>₹{grandTotal.toFixed(2)}</strong></td>
            </tr>
            <tr>
              <td colSpan="4">round off</td>
              <td>{roundOff}</td>
            </tr>
            <tr><td className="bill-total" colSpan="4"><strong>Payable Amount</strong></td>
            <td><strong>₹{payableAmount.toFixed(2)}</strong></td>
            </tr>

          </tfoot>
        </table>
        </div>

        {/* <div className="bill-actions">
          <button className="btn-primary" onClick={handlePrint}>🖨️ Print Bill</button>
          <button className="btn-primary" onClick={handlePrint}>🖨️ Print and End Session</button>
          <button className="btn-secondary" onClick={() => setShowSmsPopup(true)}>📩 Send via SMS</button>
          <button className="btn-secondary">🧾 Download PDF</button>
          <button className="btn-red">💳 End Session</button>
        </div> */}

        <div className="cart-footer" style={{ padding: "10px 10px 10px 10px" }}>
          <div className="cart-payment-type">

            <div className="cart-delivery-options">

              {deliveryOptions.map((option) => (
                <span
                  key={option.value}
                  className={OrderType === option.value ? "active" : ""}
                  onClick={() => setOrderType(option.value)}
                >
                  {option.label}
                </span>
              ))}

            </div>

            <label className="pay-option paid">
              <input
                type="checkbox"
                disabled={!showServiceCharge && !tax?.dineInServiceChargeEnabled && !tax?.pickupServiceChargeEnabled && !tax?.deliveryServiceChargeEnabled}
                checked={appliedServiceCharge}
                onChange={(e) => setAppliedServiceCharge(e.target.checked)}
              />
              <span>Service charge ({calculated.serviceChargePercent}%)</span>
            </label>


          </div>

          <PaymentAllocationEditor payableAmount={payableAmount} payments={payments} onChange={setPayments} disabled={loading} />

          <div className="settlement">
            <label className="settlement-label" htmlFor="bill-discount">Discount Amount</label>
            <input
              id="bill-discount"
              type="number"
              className="settlement-input"
              value={discount || billTaxDetails?.discountAmount || ""}
              onChange={(e) => setDiscount(e.target.value)}
            />

             <label className="settlement-label" htmlFor="bill-discount-type">Discount Type</label>
            <input
              id="bill-discount-type"
              type="text"
              className="settlement-input"
              value={discountType || billTaxDetails?.discountType || ""}
              placeholder="Offer/Coupon/Zomato/Swiggy"
              onChange={(e) => setDiscountType(e.target.value)}
            />

            <button className="settlement-btn" onClick={handleApplyDiscount}>
              Apply
            </button>

            

          </div>

          <div className="cart-action-button">
            {/* <span className="cart-button" onClick={() => setShowSmsPopup(true)}>🖨️ Print & Paid</span> */}


            <button type="button" disabled={loading}
              className="cart-button"
              onClick={() => handleSaveBill('Paid')}
              style={{ pointerEvents: loading ? "none" : "auto", opacity: loading ? 0.6 : 1 }}
            >Paid (Save as paid)</button>

            <button type="button" disabled={loading}
              className="cart-button"
              onClick={() => handleSaveBill('Paid&Print_kot')}
              style={{ pointerEvents: loading ? "none" : "auto", opacity: loading ? 0.6 : 1 }}
            >Paid (Save as paid, Print KOT only)</button>

            <button type="button" disabled={loading}
              className="cart-button"
              onClick={() => handleSaveBill('Paid&Print_bill')}
              style={{ pointerEvents: loading ? "none" : "auto", opacity: loading ? 0.6 : 1 }}
            >Paid (Save as paid, Print Bill only)</button>

            <button type="button" disabled={loading}
              className="cart-button"
              onClick={() => handleSaveBill('Paid&Print')}
              style={{ pointerEvents: loading ? "none" : "auto", opacity: loading ? 0.6 : 1 }}
            >Paid (Save as paid, Print KOT & Bill)</button>

            {[1, 2].includes(roleId) && <button type="button" disabled={loading}
              className="cart-button"
              onClick={() => handleSaveBill('Void')}
              style={{ pointerEvents: loading ? "none" : "auto", opacity: loading ? 0.6 : 1 }}
            >Void</button>}

            <button type="button" disabled={loading}
              className="cart-button"
              onClick={() => handleSaveBill('Draft')}
              style={{ pointerEvents: loading ? "none" : "auto", opacity: loading ? 0.6 : 1 }}
            >Draft</button>
          </div>

          {/* <div className="item-header" style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
  <span onClick={() => navigate("/bills")} className="back-btn item-back-btn">← Back to Bills</span>
  
  <button 
    className="bill-action-btn btn-view-details" 
    onClick={() => navigate(tableName === "DIRECT_BILL" ? "/menu" : `/menu/${tableName}`,{state: { billTaxDetails }})}
  >
    + Add More Items to Draft
  </button>
</div> */}

        </div>
      </div>
      {/* Popup */}
      {showSmsPopup && (
        <SmsPopup billId={'billid'} onClose={() => setShowSmsPopup(false)}
        />
      )}


      <PrintBill
        ref={billRef}
        OrderAndChargesDetails={OrderAndCharges}
        tableName={0}
        subTotal={subTotal}
        cgstAmount={cgstAmount}
        sgstAmount={sgstAmount}
        serviceChargeAmount={serviceChargeAmount}
        packagingCharge={packagingCharge}
        deliveryCharge={deliveryCharge}
        appliedDiscount={appliedDiscount}
        grandTotal={grandTotal}
        payableAmount={payableAmount}
        roundOff={roundOff}
        orderMode={OrderType}
        billDetails={savedBill}
      />

      <PrintKot
        ref={kotRef}
        items={Array.isArray(itemList) ? itemList : []}
        bill={savedBill}
        liveOrderKot={false}
      />
    </div>
  );
};

export default BillPage;
